module.exports = __webpack_public_path__ + "static/wedigital-6459d3bdfd98e5050f9961c1059a3932.png";